import {
  Box,
} from "@chakra-ui/react";
import CallProviders from "./components/callProviders";
import VMInstance from "./components/VMInstance";

export default function ManageToolsPage() {


  return (
    <Box padding={{ base: "15px", lg: "25px", xl: "35px", }} width="100%">
      <Box
        background="white"
        borderRadius="br.10"
        padding="16px"
        height={{ md: "calc(100vh - 110px)", lg: "calc(100vh - 150px)" }}
        overflowY="auto"
        display={"flex"}
        flexDirection={"column"}
        gap={"20px"}
      >
        <CallProviders />
        <VMInstance />
      </Box>
    </Box>
  );
}
